<template>
  <div>
    <router-link tag="a"
                 :to="{name: 'successCaseDetail',params:{ id: scase.id} }"
                 target="_blank"
                 class="card"
                 v-for="(scase,index) in cases"
                 :key="index">
      <!-- <img class="cover" :src="scase.list_img" alt=""> -->
      <div class="detail">
        <h5 class="titles">{{scase.title}}
          <p class="name"
             style="margin-left: 15px;">{{scase.alias}} &nbsp;&nbsp;&nbsp;{{scase.age}} 岁</p>
        </h5>
        <p class="sick">疾病：{{scase.disease_name}}
          <span style="margin-left: 40px;">
            就诊医院：{{scase.hospital}}
          </span>
        </p>
        <p class="name mb30"></p>
        <p class="info">{{scase.easy_brief}}</p>
      </div>
    </router-link>
    <div class="text-center mtb50">
      <Page class-name="pages"
            :total="total"
            prev-text="上一页"
            next-text="下一页"
            show-elevator
            :page-size="15"
            @on-change="changePage" />
    </div>
  </div>
</template>
<script>
// import cover from '@/assets/images/successCase/demo.jpg'
import axios from '@/api/axios'
import * as apis from '@/api/success'
import { baseURL } from '@/api/axios'
export default {
  props: {
    pageVal: Object,
    required: true
  },
  data () {
    return {
      total: 0,
      id: 1,  //当前疾病ID
      prev_page: '', //上一页
      next_page: '', //下一页
      cases: [],
      selectedResult: {}
    }
  },
  created () {
    this.selectedResult = this.pageVal
    this.selectedResult.type_id = this.$route.params.type_id;
  },
  mounted () {
    // let type_id = this.$route.params.type_id;
    // this.id = id;
    this.getCaseList(this.selectedResult, 1);
  },
  watch: {
    pageVal: {
      handler (newV, oldV) {
        this.selectedResult = this.pageVal
        this.selectedResult.type_id = this.$route.params.type_id;
        this.getCaseList(this.selectedResult, 1);
      },
      deep: true
    },
    $route: {
      handler: function (val, oldVal) {
        this.selectedResult = this.pageVal
        this.selectedResult.type_id = this.$route.params.type_id;
        this.getCaseList(this.selectedResult, 1);
      },
      deep: true
    }
  },
  methods: {
    changePage (index) {
      // let id = this.id;
      // axios.get('api/v1/web/cases/cases_list?page=' + index + '&id=' + id).then((res) => {
      //   if (res.code == 200) {
      //     window.scrollTo(0, 0);
      //     this.cases = res.data.data
      //   }
      // });
      this.getCaseList(this.selectedResult, index)
    },
    async getCaseList (obj, pageIndex) {
      try {
        let data = {}
        data = obj
        data.page = pageIndex
        let res = await apis.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data;
          this.total = res.data.total;
          this.next_page = res.data.next_page_url;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.mtb50 {
  margin: 50px 0;
}
.card {
  display: block;
  width: 980px;
  height: 156px;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  padding: 25px 30px;
  margin-bottom: 10px;
  .cover {
    float: left;
    width: 210px;
    height: 210px;
  }
  .detail {
    // margin-left: 240px;
    .titles {
      font-size: 18px;
      color: #000;
      border-bottom: 1px dashed #000;
      padding-bottom: 16px;
      margin-bottom: 18px;
    }
    .sick {
      font-size: 13.5px;
      line-height: 24px;
      color: rgb(192, 157, 88);
      margin-bottom: 10px;
    }
    .name {
      display: inline;
      font-size: 13.5px;
      line-height: 24px;
      color: #333130;
    }
    .info {
      font-size: 13.5px;
      color: #8e8d8c;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      letter-spacing: 1px;
    }
  }
}
.mb30 {
  margin-bottom: 30px;
}
</style>
